export default [
	[
		{
			name: 'visningsnavn',
			inputs: [
				{name: 'visningsnavn', propertyName: 'name', inputType: 'text', min: 1, max: 50, placeholder: 'navn'}
			]
		},
		{
			name: 'fødselsdato (ddmmåååå)',
			inputs: [
				{name: 'fødselsdato (ddmmåååå)', propertyName: 'dateOfBirth', inputType: 'text', min: 8, max: 8, placeholder: 'ddmmåååå'}
			]
		},
		{
			name: 'kjønn',
			inputs: [
				{
					name: 'kjønn',
					propertyName: 'sex',
					inputType: 'radio',
					options: ['mann', 'kvinne', 'ønsker ikke meddele'],
					required: true
				}
			]
		},
		{
			name: 'telefon',
			inputs: [
				{
					name: 'telefon',
					propertyName: 'phone.countryCode',
					inputType: 'text',
					placeholder: '47',
					default: '47',
					max: 3,
					min: 1,
					preface: <span>+</span>
				},
				{
					propertyName: 'phone.phoneNumber',
					inputType: 'tel',
					pattern: '',
					placeholder: '12345678',
					max: 15,
					min: 8
				},
			]
		},
	],
]